import { useCreateOrUpdateArtworkInExhibition } from "@/api/related-fields";
import { FieldConfig } from "@/config/forms/general";
import { ArtworkInExhibition } from "@/lib/types";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { z } from "zod";
import LinksDrawerLayout from "./LinksDrawerLayout";

const ArtworkInExhibitionDrawer = ({
  fields,
  data,
  queryId,
  type,
}: {
  fields: FieldConfig[] | undefined;
  data: ArtworkInExhibition;
  queryId: string;
  type: string;
}) => {
  const schema = z.object({
    oeuvresDansExpositionsDescriptionNumeroCatalogue: z.string().optional(),
    oeuvresDansExpositionsNotes: z.string().optional(),
    exhibition: z.object({
      expositionsDescriptionNumeroExpo: z.string(),
      expositionsDescriptionResume: z.string(),
    }),
  });

  const { mutate: createOrUpdateArtworkInExhibition } =
    useCreateOrUpdateArtworkInExhibition(queryId, type);

  const form = useForm<z.infer<typeof schema>>({
    resolver: zodResolver(schema),
    defaultValues: {
      exhibition: data.exhibition,
      oeuvresDansExpositionsDescriptionNumeroCatalogue:
        data.oeuvresDansExpositionsDescriptionNumeroCatalogue,
      oeuvresDansExpositionsNotes: data.oeuvresDansExpositionsNotes,
    },
  });

  const onSubmit = (formData: z.infer<typeof schema>) => {
    createOrUpdateArtworkInExhibition({
      id: data.id ?? "",
      oeuvresDansExpositionsDescriptionNumeroCatalogue:
        formData.oeuvresDansExpositionsDescriptionNumeroCatalogue,
      oeuvresDansExpositionsNotes: formData.oeuvresDansExpositionsNotes,
      artworkId: data.artwork.id,
      exhibitionId: data.exhibition.id,
    });
  };

  return (
    <LinksDrawerLayout
      form={form}
      fields={fields ?? []}
      recordId={data.id}
      onSubmit={onSubmit}
    />
  );
};

export default ArtworkInExhibitionDrawer;
